import {
  initialState,
  Actions,
  State,
  NEW_DISCOUNT,
  NEW_DISCOUNT_SUCCESS,
  NEW_DISCOUNT_ERROR,
  RESET_NEW_DISCOUNT,
} from "../../types/discount/new-discount";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_DISCOUNT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_DISCOUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_DISCOUNT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_DISCOUNT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
